import React from "react";

const Time = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-time"
      data-name="icon-time"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width={_width}
      {...props}
    >
      <path d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm1,12c0,.552-.448,1-1,1h-4c-.552,0-1-.448-1-1s.448-1,1-1h3V6c0-.552,.448-1,1-1s1,.448,1,1v6Z" />
    </svg>
  );
};

export default Time;
